import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { ChangeSimpleDateString,PassedMonths,GetChildrenState,LoginAfterCheckLogin,isNull } from "../../components/common/Common";

import "../../css/style.css";


//발달 분석 및 평가
const AnalysisSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varSemesterIndex,setSemesterIndex] = useState(0);
  const [varSemesterList,setSemesterList] = useState([]);

  const [varMamaRoomList,setMamaRoomList] = useState([]);
  const [varFlyRoomList,setFlyRoomList] = useState([]);

  const [varSearchName,setSearchName] = useState("");
  const [varClassIndex,setClassIndex] = useState(-1);
  const [varClassList,setClassList] = useState([]);
  const [varClassRoomList,setClassRoomList] = useState([]);

  const [varTotalCount,setTotalCount] = useState(0);
  const [varChildrenList,setChildrenList] = useState([]);
  
  //발달 분석 및 평가를 위한 조건 가져오기
  const GetSemesterInformation = async(semesterIndex) => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_current_semester`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setSemesterList(datas.semesters);
        if(semesterIndex > 0) setSemesterIndex(semesterIndex);
        else setSemesterIndex(datas.semesters[0].sm_idx);
        /* const semesterInfo = datas.results;
        if(semesterInfo.length === 0) {
          alert('현재 진행중이거나 진행된 학기가 없습니다.');
          navigate('/Branch/SemesterSet');
          return false;
        } else {
          const edate = new Date(semesterInfo[0].sm_edate);
          const sdate = new Date(semesterInfo[0].sm_sdate);
          const today = new Date();

          if(sdate > today) {
            alert('아직 학기가 시작되지 않아 평가할 대상이 없습니다.');
            navigate('/Branch/SemesterSet');
            return false;
          }
          if(edate < today) {
            alert('진행중이거나 진행할 학기가 등록되어 있지 않습니다. 먼저 학기/클래스/교실등을 먼저 등록하세요');
            navigate('/Branch/SemesterSet');
            return false;
          }
        }  */

        /* const sm_idx = semesterInfo[0].sm_idx;
        //setSemesterIndex(sm_idx);
        GetAnalisysInformation(sm_idx); */
      }
    });
  }

  //발달 분석 및 평가를 위한 조건 가져오기
  const GetAnalisysInformation = async() => {
    const sendData = {branch_idx:branch_idx,sm_idx:varSemesterIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_analisys`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setMamaRoomList(datas.mamamontes);
        setFlyRoomList(datas.flys);
        GetClassForClassRoom(varClassRoomList);
      }
    });
  }

  //교실을 선택하면 클래스 목록 가져오기
  const GetClassForClassRoom = async(roomList) => {
    const sendData = {branch_idx:branch_idx,sm_idx:varSemesterIndex,classrooms:roomList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_byrooms`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setClassList(datas.classes);
        setClassIndex(0);
        GetClassStudyWithChildrens(roomList,0);
      }
    });
  } 

  //검색조건에 맞는 원생 수업정보 가져오기
  const GetClassStudyWithChildrens = async(roomList,classIndex) => {
    const sendData = {branch_idx:branch_idx,sm_idx:varSemesterIndex,searchName:varSearchName,classrooms:roomList,cl_idx:classIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_study_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        setChildrenList(datas.childrens);
      } else {
        setTotalCount(0);
        setChildrenList([]);
      }
    });
  }  

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //현재 사용중인 학기가 존재하면
    let semesterIndex = 0;
    if(!isNull(localStorage.getItem('semesterIndex'))) {
      semesterIndex = Number(localStorage.getItem('semesterIndex'));
      //setSemesterIndex(semesterIndex);
    }
    GetSemesterInformation(semesterIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

/*   //교실변경시
  useEffect(() => {
    console.log('bbb')
    if(varClassRoomList.length === 0) {
      setClassList([]);
      setClassIndex(0);
    } else {
      GetClassForClassRoom();
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassRoomList]); */

  useEffect(() => {
    console.log(varSemesterIndex);
    GetAnalisysInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSemesterIndex]);

  //학기선택
  const onSelectSemesterIndex = (e) => {
    const sm_idx = Number(e.currentTarget.value);
    setSemesterIndex(sm_idx);
    localStorage.setItem('semesterIndex',sm_idx);
  }

  //클래스 변경시
  useEffect(() => {
    if(varClassIndex > 0) GetClassStudyWithChildrens(varClassRoomList,varClassIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassIndex]);

  //교실선택
  const onSelectClassRoomHandler = (e,itype) => {
    const ichecked = Number(e.currentTarget.checked);
    const cr_idx = Number(e.currentTarget.value);
    console.log(ichecked,cr_idx);
    if(itype === 1) {
      const mamaList = [...varMamaRoomList];
      const findIndex = mamaList.findIndex(el=>el.cr_idx === cr_idx);
      mamaList[findIndex].cr_checked = ichecked;
      setMamaRoomList(mamaList);
    } else {
      const flyList = [...varFlyRoomList];
      const findIndex = flyList.findIndex(el=>el.cr_idx === cr_idx);
      flyList[findIndex].cr_checked = ichecked;
      setFlyRoomList(flyList);
    }
    let newList = [];
    if(ichecked) newList = varClassRoomList.concat(cr_idx);
    else newList = varClassRoomList.filter(el=>el !== cr_idx);
    console.log(ichecked,newList);
    setClassRoomList(newList);
    if(newList.length === 0) setClassIndex(0);
    GetClassForClassRoom(newList);
  }

  //검색명
  const onChangeSearchingHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "search_name") setSearchName(value);
    else if(name === "cl_idx") setClassIndex(Number(value));
  }

  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    GetClassStudyWithChildrens(varClassRoomList,varClassIndex);
  }

  //다음페이지
  const onLinkPageHandler = (e,childrens) => {
    const clc_idx = childrens.clc_idx;
    if(childrens.cl_type === 1) {
      if(childrens.clc_ev_idx === 0) navigate(`/Branch/MamaMonteDetail/${clc_idx}`);
      else navigate(`/Branch/MamaMonteView/${childrens.clc_idx}`);
    } else {
      if(childrens.clc_ev_idx === 0) navigate(`/Branch/FlyDetail/${clc_idx}`);
      else navigate(`/Branch/FlyView/${childrens.clc_idx}`);
    }
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'발달 분석 및 평가'} varBackString={'none'}/>
      <div className="vh-content-body">
        <div className="ct-mdt-wrap">
          <div className="center-wrap">
            {/* 학기 선택 */}
            <div className="sem-select-wrap">
              <label>학기 선택</label>
              <select name="" value={varSemesterIndex} onChange={e=>onSelectSemesterIndex(e)}>
                <option value={0}>전체 학기</option>
                {varSemesterList.map((semester,i)=>(
                  <option key={'semester_'+i} value={semester.sm_idx}>{semester.sm_name}</option>
                ))}
              </select>
              <div className="search-inp-wrap" style={{marginTop:"20px"}}>
                <input type="text" name="search_name" className="search-input" placeholder="원생명으로 검색" value={varSearchName} onChange={e=>onChangeSearchingHandler(e)}/>
                <button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
              </div>
            </div>
            <div className="select-wrap">
              <div className="box01">
                <label>교실 선택</label>
                <div className="sel-box">
                  <p>마마몽떼</p>
                  {varMamaRoomList.map((mamas,i)=>(
                    <div key={'mamas_'+i} className="chk-group flex">
                      <input type="checkbox" value={mamas.cr_idx} name="cr_idx" id={mamas.cr_name} checked={mamas.cr_checked} onChange={e=>onSelectClassRoomHandler(e,1)}/>
                      <label htmlFor={mamas.cr_name}>{mamas.cr_name}</label>
                    </div>
                  ))}
                </div>
                <div className="sel-box">
                  <p>플라이</p>
                  {varFlyRoomList.map((flys,i)=>(
                    <div key={'flys_'+i} className="chk-group flex">
                      <input type="checkbox" value={flys.cr_idx} name="cr_idx" id={flys.cr_name} checked={flys.cr_checked} onChange={e=>onSelectClassRoomHandler(e,2)}/>
                      <label htmlFor={flys.cr_name}>{flys.cr_name}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="box02">
								<label>클래스 선택</label>
								<select name="cl_idx" value={varClassIndex} onChange={e=>onChangeSearchingHandler(e)}>
									<option value={0}>전체 클래스</option>
                  {varClassList.map((classes,i)=>(
                    <option key={'classes_'+i} value={classes.cl_idx}>{classes.cl_name}</option>
                  ))}
								</select>
							</div>
            </div>

            <div className="search-ok-con">
              <div className="top-line2">
								<p>전체 {varTotalCount}건</p>
							</div>
              {varChildrenList.length === 0?null:
                varChildrenList.map((childrens,i)=>(
                  <div key={'childrens_'+i} className="con-box">
                    <div className="txt-box">
                      <div className="kids-line">
                        <p className="kids">{childrens.ch_name} {PassedMonths(childrens.ch_birthday)}개월</p>
                        <div className="date">{ChangeSimpleDateString(childrens.ch_birthday)} ({GetChildrenState(childrens.ch_status)})</div>
                      </div>
                      <div className="flex">
                        <p>학기명</p>
                        <div>{childrens.sm_name}</div>
                      </div>
                      <div className="flex">
                        <p>클래스</p>
                        <div>{childrens.cl_name}</div>
                      </div>
                      <div className="flex">
                        <p>차수</p>
                        <div>{childrens.pass_cnt}/{childrens.tstudys}</div>
                      </div>
                      <div className="flex">
                        <p>평가일</p>
                        <div>{ChangeSimpleDateString(childrens.clc_adate)}</div>
                      </div>
                    </div>
                    <button className={childrens.clc_ev_idx===0?"btn-st01":"btn-st02"} onClick={e=>onLinkPageHandler(e,childrens)}>
                      {childrens.clc_ev_idx===0?"평가":"수정"}
                    </button>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default AnalysisSet;